import * as utils from './tools'
export default function initGlobalFilters(Vue) {
  Vue.filter('dateFormat', utils.dateFormat)
  Vue.filter('filterImage', utils.filterImage)
}
